import { render } from "./OimAppointments.vue?vue&type=template&id=eab362a0"
import script from "./OimAppointments.vue?vue&type=script&lang=js"
export * from "./OimAppointments.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__